






















































































import { Component, Mixins, Prop, PropSync, Ref } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { ProviderInstance } from 'vee-validate/dist/types/types';
import Tag from '@/components/familyPortal/removeableTag/Tag.vue';
import { ScreenText } from '@/lang/ScreenText';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import AccountSettings from '@/mixins/accountSettings.mixin';
import cartStore from '@/store/modules/checkout/cart/module';
import { registerRequiredValidator, registerAlphaNumValidator } from '@/validators/validators';
import Spinner from '@/commoncomponents/spinner/Spinner.vue';
import commonEntry from '@/store/modules/commonEntry';
import APP_CONST from '@/constants/AppConst';

@Component({
  components: {
    Spinner,
    Tag,
    ValidationProvider
  }
})
export default class PromoCode extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  @Prop({ type: String }) errorMessage?: string;
  @PropSync('disabled', { required: true, type: Boolean }) disabledSync!: boolean;

  public readonly screenText = new ScreenText();
  cart = cartStore;
  APP_CONST = APP_CONST;
  promoCode: string = (this.cart.promoCodeCartObject && this.cart.promoCodeCartObject.promoCode) || this.cart.promoCode || '';

  @Ref('promo-code-validator') promoCodeValidator?: ProviderInstance;

  created() {
    this.registerValidators();
  }

  private registerValidators() {
    registerRequiredValidator('');
    registerAlphaNumValidator('');
  }

  get isFetchingPromoCode(): boolean {
    return this.cart.isFetchingCartForPromoCode;
  }

  get percentOff(): string {
    const promoCodePercent = this.cart.promoCodeDiscountPercent || 0;
    const percentOffSuffix = this.screenText.getScreenText('CHECKOUT_PROMO_CODE_PERCENT_OFF');
    return `${promoCodePercent}${percentOffSuffix}`;
  }

  get promoCodeValidationProviderRules(): Record<string, any> {
    return {
      alpha_num: true,
      required: true
    };
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor;
  }

  get disableApply(): boolean {
    return this.cart.hasPromoCodeError || !this.promoCode || (!!this.promoCodeValidator && this.promoCodeValidator.errors.length > 0) || this.cart.isFetchingCart;
  }

  async applyPromoCode() {
    if (!this.disableApply) {
      cartStore.SET_FETCHING_CART_FOR_PROMO_CODE(true);
      await this.cart.fetchCartForUser();
      cartStore.SET_FETCHING_CART_FOR_PROMO_CODE(false);
    }
  }

  onPromoCodeChange(e: Event) {
    const target = e.target as HTMLInputElement;
    this.cart.SET_PROMO_CODE(target.value);
  }

  async removePromoCode() {
    this.cart.SET_PROMO_CODE('');
    cartStore.SET_FETCHING_CART_FOR_PROMO_CODE(true);
    await this.cart.fetchCartForUser();
    this.promoCode = '';
    cartStore.SET_FETCHING_CART_FOR_PROMO_CODE(false);
  }

}
